export default __webpack_public_path__ + "static/media/09_photo.d3feb262.jpg";